module.exports = __webpack_public_path__ + "img/mission_price_panel.5eea77f3.png";